/**
 * KAN-752: включённые операторы канала и нужен ли явный выбор кампании.
 *
 * Ключ под USERS_QUERY_KEY: создание кампании или правка канала оператора
 * (инвалидация списка пользователей) обновляет и этот список.
 */
import { useQuery } from '@tanstack/react-query';
import { channelOperatorsApi, type ChannelOperator } from '@/services/api/channelOperators';
import { USERS_QUERY_KEY } from '@/services/api/queryKeys';
import { needsOperatorChoice } from '@/lib/channelOperators';

export function channelOperatorsKey(channel: string) {
  return [...USERS_QUERY_KEY, 'channel-operators', channel] as const;
}

export interface ChannelOperatorsState {
  operators: ChannelOperator[];
  /** Операторов больше одного: кампанию нужно выбрать. */
  choiceRequired: boolean;
  isLoading: boolean;
}

export function useChannelOperators(channel: string, enabled = true): ChannelOperatorsState {
  const { data, isLoading } = useQuery({
    queryKey: channelOperatorsKey(channel),
    queryFn: () => channelOperatorsApi.list(channel),
    enabled,
    staleTime: 60_000,
  });
  const operators = data ?? [];
  return {
    operators,
    choiceRequired: needsOperatorChoice(operators),
    isLoading: enabled && isLoading,
  };
}
